import React, { useReducer } from 'react';
import { IonButton } from '@ionic/react';
import Tutorial from '../components/Tutorial';
import GameMainMenu from '../components/uiElements/regular/MainMenu';
import ReactTools from '../core/Misc/ReactTools';
import { customRouter } from '../CustomRouter';
import { Windows } from './MainPage';
const reducer = (state: any, action: any) => {
	var result = ReactTools.generalReducer(state, action);
	switch (action.type) {
	case 'setWindow':
		result = {...state, currentWindow: action.value};
		break;
	}
	return result;
};
const windowMainMenu = 0;
const windowTutorial = 1;
const MainMenuPage = (props: any) => {
	const [state, dispatch] = useReducer(reducer, {
		currentWindow: windowMainMenu
	});
	var onTutorialClicked = () => {
		dispatch({
			type: 'setWindow',
			value: windowTutorial
		});
	};

	const defaultMainMenu = {
		menuScenarios: [{
			id: 1,
			title: 'Hit by vehicle',
			text: 'HIT BY VEHICLE - OVERVIEW',
            description: 'As you were leaving work, walking to your car, you saw an accident take place. A pedestrian was hit by a fast-moving vehicle. The victim has serious bleeding from the left upper arm. As you carefully approach the scene, you need to properly recognize serious bleeding and demonstrate the proper usage of direct pressure bleeding control.',
			//link: process.env.PUBLIC_URL + "/game/PracticeScenarioA",
			link: Windows.PracticeScenarioA,
			background: "./assets/img/hit_by_vehicle_bg.png",
			backgrounds: ["./assets/img/sc-a-hit_by_vehicle_bg-a.png","./assets/img/sc-a-hit_by_vehicle_bg-b.png","./assets/img/sc-a-hit_by_vehicle_bg-c.png"],
			audio: "./assets/audio/06-Scenario A/BC-Scenario-A-Step-1-Part-1.mp3"
		}, {
			id: 2,
			title: 'circular saw injury',
			text: 'CIRCULAR SAW INJURY - OVERVIEW',
			link: Windows.PracticeScenarioB,
			//link: process.env.PUBLIC_URL + "/game/PracticeScenarioB",
			description: 'As you were patrolling the building exterior, you saw an accident happen where a construction worker got deeply cut by his circular hand saw. The victim has serious bleeding from the right lower forearm. As you arrive at the scene, you are to properly recognize hemorrhage control needs and determine the best steps to control the bleeding.',
			background: "./assets/img/hit_by_vehicle_bg.png",
			backgrounds: ["./assets/img/sc-b-hit_by_vehicle_bg-a.png","./assets/img/sc-b-hit_by_vehicle_bg-b.png","./assets/img/sc-b-hit_by_vehicle_bg-c.png"],
			audio: "./assets/audio/07-Scenario B/BC-Scenario-B-Step-1-Part-1.mp3",
		}, {
			id: 3,
			title: 'gunshot wound',
			text: 'GUNSHOT WOUND - OVERVIEW',
			link: Windows.PracticeScenarioC,
			// link: process.env.PUBLIC_URL + "/game/PracticeScenarioC",
			description: 'The sound of gunshots emerged from within the VA clinic. As you approach the lobby, the shooter has been taken into custody, and you see a gunshot victim.The victim has serious bleeding from their left leg. It\'s time to properly recognize hemmorage control needs and determine the best steps to control the bleeding.',
			background: "./assets/img/hit_by_vehicle_bg.png",
			backgrounds: ["./assets/img/sc-c-hit_by_vehicle_bg-a.png","./assets/img/sc-c-hit_by_vehicle_bg-b.png","./assets/img/sc-c-hit_by_vehicle_bg-c.png"],
			audio: "./assets/audio/08-Scenario C/BC-Scenario-C-Step-1-Part-1.mp3"
		}, {
			id: 4,
			title: 'gas leak explosion',
			text: 'GAS LEAK - OVERVIEW',
			link: Windows.PracticeScenarioD,
			//link: process.env.PUBLIC_URL + "/game/PracticeScenarioD",
			description: 'A gas leak caused an explosion near the parking garage at the VA facility. The victim who was very close to the explosion has suffered a traumatic amputation and is bleeding from his lower leg stump. Now it is time to properly recognize hemorrhage control needs and determine the best steps to control the bleeding.',
			background: "./assets/img/hit_by_vehicle_bg.png",
			backgrounds: ["./assets/img/sc-d-hit_by_vehicle_bg-a.png","./assets/img/sc-d-hit_by_vehicle_bg-b.png","./assets/img/sc-d-hit_by_vehicle_bg-c.png"],
			audio: "./assets/audio/09-Scenario D/BC-Scenario-D-Step-1-Part-1.mp3"
		},{
			id: 5,
			title: 'Hit by vehicle',
			text: 'HIT BY VEHICLE - TEST SCENARIO',
            description: 'As you were leaving work, walking to your car, you saw an accident take place. A pedestrian was hit by a fast-moving vehicle. The victim has serious bleeding from the left upper arm. As you carefully approach the scene, you need to properly recognize serious bleeding and demonstrate the proper usage of direct pressure bleeding control.',
			link: Windows.TestScenarioA,
			//link: process.env.PUBLIC_URL + "/game/TestScenarioA",
			background: "./assets/img/hit_by_vehicle_bg.png",
			backgrounds: ["./assets/img/sc-a-hit_by_vehicle_bg-a.png","./assets/img/sc-a-hit_by_vehicle_bg-b.png","./assets/img/sc-a-hit_by_vehicle_bg-c.png"],
			audio: "./assets/audio/06-Scenario A/BC-Scenario-A-Step-1-Part-1.mp3"
		}, {
			id: 6,
			title: 'circular saw injury',
			text: 'CIRCULAR SAW INJURY - TEST SCENARIO',
			link: Windows.TestScenarioB,
			//link: process.env.PUBLIC_URL + "/game/TestScenarioB",
			description: 'As you were patrolling the building exterior, you saw an accident happen where a construction worker got deeply cut by his circular hand saw. The victim has serious bleeding from the right lower forearm. As you arrive at the scene, you are to properly recognize hemorrhage control needs and determine the best steps to control the bleeding.',
			background: "./assets/img/hit_by_vehicle_bg.png",
			backgrounds: ["./assets/img/sc-b-hit_by_vehicle_bg-a.png","./assets/img/sc-b-hit_by_vehicle_bg-b.png","./assets/img/sc-b-hit_by_vehicle_bg-c.png"],
			audio: "./assets/audio/07-Scenario B/BC-Scenario-B-Step-1-Part-1.mp3"
		}, {
			id: 7,
			title: 'gunshot wound',
			text: 'GUNSHOT WOUND - TEST SCENARIO',
			link: Windows.TestScenarioC,
			//link: process.env.PUBLIC_URL + "/game/TestScenarioC",
			description: 'The sound of gunshots emerged from within the VA clinic. As you approach the lobby, the shooter has been taken into custody, and you see a gunshot victim.The victim has serious bleeding from their left leg. It\'s time to properly recognize hemmorage control needs and determine the best steps to control the bleeding.',
			background: "./assets/img/hit_by_vehicle_bg.png",
			backgrounds: ["./assets/img/sc-c-hit_by_vehicle_bg-a.png","./assets/img/sc-c-hit_by_vehicle_bg-b.png","./assets/img/sc-c-hit_by_vehicle_bg-c.png"],
			audio: "./assets/audio/08-Scenario C/BC-Scenario-C-Step-1-Part-1.mp3"
		}, {
			id: 8,
			title: 'gas leak explosion',
			text: 'GAS LEAK - TEST SCENARIO',
			link: Windows.TestScenarioD,
			//link: process.env.PUBLIC_URL + "/game/TestScenarioD",
			description: 'A gas leak caused an explosion near the parking garage at the VA facility. The victim who was very close to the explosion has suffered a traumatic amputation and is bleeding from his lower leg stump. Now it is time to properly recognize hemorrhage control needs and determine the best steps to control the bleeding.',
			background: "./assets/img/hit_by_vehicle_bg.png",
			backgrounds: ["./assets/img/sc-d-hit_by_vehicle_bg-a.png","./assets/img/sc-d-hit_by_vehicle_bg-b.png","./assets/img/sc-d-hit_by_vehicle_bg-c.png"],
			audio: "./assets/audio/09-Scenario D/BC-Scenario-D-Step-1-Part-1.mp3"
		}
		],
		howToPlay: {
			//onClick: () => {window.location.href = process.env.PUBLIC_URL + "/tutorial"}
			onClick: () => {props.updateWindow(Windows.Tutorial)}
		}
	}

	const renderMainMenu = () => {
		return (
			<div>
				<GameMainMenu updateWindow={props.updateWindow} {...defaultMainMenu}/>
				{/* <p>MainMenuPage</p>
				<IonButton onClick={onTutorialClicked}>Tutorial</IonButton>
				<IonButton routerLink="/game/PracticeScenarioC">Start Game</IonButton> */}
			</div>
		);
	};

	const renderWindow = () => {
		switch(state.currentWindow){
		case windowMainMenu:
			return renderMainMenu();
		case windowTutorial:
			return (<Tutorial></Tutorial>);
		}
	};

	return (
		<div>
			{renderWindow()}
		</div>
	);
};

export default MainMenuPage;
